<template>
    <section class="tabbed-view">
        <div class="tab-container">
            <TabbedViewTabs :tabs="tabs" :active.sync="activeInternal" :class="tabType">
                <template v-for="slotName in slotNames" #[getTabSlotName(slotName)]="props">
                    <slot :name="getTabSlotName(slotName)" v-bind="props" />
                </template>
            </TabbedViewTabs>

            <div class="tab-right">
                <slot name="tab-right" />
            </div>
        </div>

        <keep-alive v-for="slotName in slotNames" :key="slotName">
            <tab v-if="activeSlotName === slotName">
                <slot :name="slotName" />
            </tab>
        </keep-alive>
    </section>
</template>
<script>
import TabbedViewTabs from './tabbed-view-tabs.vue'

const tab = {
    render(createElement) {
        return createElement('div', { class: 'tabbed-view-content' }, this.$slots.default)
    },
}

function getSlotName(tabName) {
    return tabName.replace(/[^0-9a-zA-Z]+/g, '-').toLowerCase()
}

export default {
    model: {
        prop: 'active',
        event: 'update:active',
    },
    components: {
        tab,
        TabbedViewTabs,
    },
    props: {
        active: String,
        tabs: {
            default: () => [],
            type: Array,
        },
        tabType: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            activeData: null,
        }
    },
    watch: {
        active() {
            this.activeData = null
        },
    },
    computed: {
        slotNames() {
            return this.tabs.map(getSlotName)
        },
        activeSlotName() {
            return getSlotName(this.activeInternal)
        },
        activeInternal: {
            get() {
                const specified = this.activeData || this.active
                return this.tabs.find(t => t === specified) || this.tabs[0] || ''
            },
            set(value) {
                this.activeData = value
                this.$emit('update:active', value)
            },
        },
    },

    methods: {
        getTabSlotName(slotName) {
            return `${slotName}-tab`
        },
    },
}
</script>
<style>
.tabbed-view {
    .tab-container {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .tabbed-view-tabs {
            margin-bottom: 24px;
        }

        .tab-right {
            align-items: center;
            display: flex;
            justify-content: flex-end;
            flex-grow: 1;
            margin-bottom: 32px;
        }
    }
}

@media (max-width: 768px) {
    .tabbed-view {
        .tab-container {
            .tabbed-view-tabs {
                justify-content: center;
                width: 100%;

                li {
                    padding: 16px 4px;
                    flex: 1 1 25%;
                    text-align: center;
                }
            }
        }
    }
}

@media (max-width: 320px) {
    .tabbed-view {
        .tab-container {
            margin-bottom: 8px;
        }
    }
}
</style>
